import React, { useEffect } from 'react'
import Navbar2 from '../Components/Navbar2'
import Footer2 from '../Components/Footer2'
import Aos from 'aos'

function Assessment() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  return (
    <>
      <div className="new-home"   >
        <Navbar2 />
        <div className="flex md:flex-row flex-col justify-between md:pl-[80px] pl-[20px] md:gap-0 gap-[50px] items-center md:pr-[153px] pr-[20px] mt-[38px]">
          <div>
            <img data-aos="flip-up" src="/assets/a/img2.svg" alt="" />
          </div>
          <div data-aos="fade-up">
            <img data-aos="flip-up" src="/assets/a/img3.svg" alt="" />
          </div>
        </div>
        <div className='grid xl:grid-cols-2 lg:grid-cols-1 grid-cols-1 xl:gap-[40px] md:gap-[20px] gap-[38px] md:px-[150px] px-[20px] items-start'>
          <div>
            <img data-aos="flip-up" src="/assets/a/img1.svg" alt="" />
          </div>
          <div className='bg-[#FFFFFF] py-[30px] xl:px-[40px] lg:px-[20px] px-[20px] my-[20px] border-[14px] border-[#FDD60D] rounded-[30px]'>
            <h6 className="font-[500] font-sans md:text-[31px] text-[20px] md:leading-[42px] leading-[32px] text-center text-[#6953A3]">Unlock the power og Ai-driven intelligence with GISUL's next generation assessment Solutions! Our advanced platform delivers a cutting-edge artificial intelligence to measure technical, cognitive, and behavioral competencies with unparalleled accuracy. </h6>
            <p className="font-[400] font-sans md:text-[16px] text-[11px] md:leading-[26px] leading-[22px] text-center text-[#6953A3]">With AI-powered analytics, our assessments go beyond traditional methods, offering deep insights, identifying strengths, detecting hidden skill gaps, and predicting future performance. this ensures smarter hiring, data-driven training, and  personalized professional development empowering organizations to build high-performing teams with confidence. <br /> Experience the future of assessments with GISUL's intelligent,efficient, and bias-free AI Solutions</p>
          </div>
        </div>

        {/* <div className='train'>
          <div className='train-left'>
            <img src={img} />

          </div>
          <div className='train-right'>
            <div className='idea-box'>

            </div>
            <img src={img2} />

          </div>
        </div> */}
        <Footer2 />
      </div>
    </>
  )
}

export default Assessment